import firebase from 'firebase/app';
import { get } from '../../api/client';
import { Paddock } from './paddockType';
import 'firebase/auth';

export const getPaddocks = async (farmId: number, from: string, to: string): Promise<Paddock[]> => {
    const token = await firebase.auth().currentUser?.getIdToken();
    return await get(token!, `paddocks/farm/${farmId}/from/${from}/to/${to}`);
};
